import script from "./ProfileViewTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileViewTabs.vue?vue&type=script&setup=true&lang=js"

import "./ProfileViewTabs.vue?vue&type=style&index=0&id=598c4e94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-598c4e94"]])

export default __exports__